import { idSchema } from "@reactive-resume/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const createCoverLetterSchema = z.object({
  content: z.string().optional().default(""),
  resumeId: idSchema,
});

export class CreateCoverLetterDto extends createZodDto(createCoverLetterSchema) {}
